import { HttpService } from '@/utils/http/index'
const $http = new HttpService()

/**
 * js 错误上报
 * @param data
 */
export const saveJsError = (data: object) => $http.post('/cake_api/record_error_msgs', data)

/**
 * 敏感词校验
 * @param str
 */
export const checkIsSensitive = (str: string) => $http.post('/cake/bd_examine', { text: str })